import { useTranslation } from 'react-i18next'

// local imports
import { ISideBarModel, VisiblePlan } from 'types/CalendarType'
import { isObjEmpty } from 'utils/Miscellaneous'
import DateUtil from 'utils/DateUtil'
import ParkAreaEdit from '../../calendar-park-area/EditParkArea'
// assets
import OptionIcon from 'assets/icons/options.png'
import locationMarkerGray from 'assets/icons/location-marker-gray.svg'
import binaGray from 'assets/icons/bina-gray.svg'
import listView from 'assets/icons/list-branch.svg'
import avatar from 'assets/icons/avatar.svg'
import masaGray from 'assets/icons/masa-gray.svg'
import homeImg from 'assets/icons/home-gray.svg'

interface ComponentProps {
  refreshCalendar: () => void
  model: ISideBarModel[]
  isParkAreaServiceExist?: boolean
  getAlertRedirect: (value: any) => void
}

export default function MultiSidebarInfo(props: ComponentProps) {
  const { t } = useTranslation()
  let dayListElements: JSX.Element[] = []
  let selectedDays = props.model.filter((item) => item.day.isChecked)
  const hasNoEvent = selectedDays.every((item) => isObjEmpty(item.event))

  const getSideBarInfoRender = () => {
    let dayList = props.model.filter((item) => item.day.isChecked)
    dayList.sort((day1, day2) => day1.day.date - day2.day.date)

    if (hasNoEvent) {
      dayListElements.push(
        <div
          style={{ borderBottom: '2px solid #dedede', borderTop: '2px solid #dedede' }}
          className=" d-flex justify-content-center align-items-center w-100 h-100">
          <span className="fw-bold"> {t('sidebar.no-reservation')}.</span>
        </div>
      )

      return dayListElements
    }

    dayList.forEach((value) => {
      if (value.planType === VisiblePlan.HOME_PLAN) {
        dayListElements.push(
          <div className="m-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={value.day.date.toString()}>
            <div className="of-plandate of-plandate-label mt-1">
              <strong>
                {DateUtil.dateFormat(value.event?.reservationDate) + ' - ' + DateUtil.formatDayofWeek(value.day?.date)}
              </strong>
              <div className="of-label of-work-remote ">
                <span>{t('plantype.work-from-remote-label')}</span>
                <img alt="remote" src={homeImg} />
              </div>
            </div>
            <div className="of-plandate mt-2">
              <p>
                <i className="pi pi-home mx-2" style={{ color: '#BFBFBF' }}></i>
                <span>{t('most-used-words.location')}: </span>
                {value.event.description || value.event.locationName || t('dashboard.remote-office-notification')}
              </p>
              {value.event.remoteOfficeType !== null && value.event.remoteOfficeType !== '' ? (
                <p>
                  <img src={OptionIcon} className="mx-1" width={'25px'} alt="remote-plan-icon" />
                  <span>{t('input-texts.remote-office-type')}: </span>
                  {value.event.remoteOfficeType}
                </p>
              ) : null}
            </div>
          </div>
        )
      } else if (value.planType === VisiblePlan.OFFICE_PLAN) {
        dayListElements.push(
          <div className="my-2 mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={value.day.date.toString()}>
            <div className="of-plandate of-plandate-label mt-1">
              <strong>
                {DateUtil.dateFormat(value.event?.reservationDate) + ' - ' + DateUtil.formatDayofWeek(value.day?.date)}
              </strong>
              <div className="of-label of-work-office ">
                <span>{t('plantype.work-from-office-label')}</span>
                <img alt="" />
              </div>
            </div>
            <div className="of-plandate mt-2">
              <p>
                <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
                <span> {t('most-used-words.location')}: </span>{' '}
                {value.event?.locationFirmName + ', ' + value.event?.locationName}
              </p>
            </div>
            <div className="d-flex of-plan-location-block">
              <img src={binaGray} alt="" />
              <p>
                <span>{t('most-used-words.block')}: </span>
                {value.event?.blockName}
                <br />
                <span>{t('most-used-words.floor')}: </span>
                {value.event?.floorName}
              </p>
            </div>
            <div className="of-plandate">
              <div className="d-flex w-100 align-items-center justify-content-between">
                <div>
                  <p>
                    <img className="of-office-plan-icon" src={masaGray} alt="" />
                    <span>{t('calendar.table-no')}: </span> {value.event?.tableNum}
                  </p>
                </div>
                <button
                  onClick={() => props.getAlertRedirect(value)}
                  className="my-2"
                  style={{ background: 'transparent', color: '#333', textDecoration: 'underline', border: 'none' }}>
                  {t('buttons.go-to-tableplan')}
                </button>
              </div>
            </div>
          </div>
        )
      } else if (value.planType === VisiblePlan.COMMON_PLAN) {
        dayListElements.push(
          <div className="my-2 mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={value.day.date.toString()}>
            <div className="of-plandate of-plandate-label mt-1">
              <strong>
                {DateUtil.dateFormat(value.event?.reservationDate) + ' - ' + DateUtil.formatDayofWeek(value.day?.date)}
              </strong>
              <div className="of-label of-shared-office ">
                <span>{t('plantype.work-from-shared-label')}</span>
                <img alt="" />
              </div>
            </div>
            <div className="of-plandate mt-2">
              <div className="d-flex justify-content-between">
                <p>
                  <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
                  <span> {t('most-used-words.location')}: </span>{' '}
                  {value.event?.locationFirmName + ', ' + value.event?.locationName}
                </p>

                {value?.event?.parkAreaReservation?.length > 0 && (
                  <div className="of-label of-campus-park">
                    <span>{t('plantype.campus-park-label')}</span>
                    <img alt="" />
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex of-plan-location-block">
              <img src={binaGray} alt="" />
              <p>
                <span>{t('most-used-words.block')}: </span>
                {value.event?.blockName}
                <br />
                <span>{t('most-used-words.floor')}: </span>
                {value.event?.floorName}
              </p>
            </div>
            <div className="of-plandate">
              <p>
                <img className="of-office-plan-icon" src={masaGray} alt="" />
                <span>{t('calendar.table-no')}: </span> {t('sidebar.table-without-choice')}.
              </p>

              <ParkAreaEdit
                serviceIsExists={props?.isParkAreaServiceExist}
                resDate={value?.event?.reservationDate}
                parkRes={value?.event?.parkAreaReservation?.[0]}
                refreshCalendar={props.refreshCalendar}
              />
            </div>
          </div>
        )
      } else if (
        value.planType === VisiblePlan.NEW_PLAN &&
        (value.event?.doctorReservation?.length > 0 ||
          value.event?.coiffeurReservation?.length > 0 ||
          value.event.gymGroupLessonReservation?.length > 0 ||
          value.event.gymSaloonReservation?.length > 0 ||
          value.event.gymTrainerReservation?.length > 0 ||
          value.event.lactationReservation?.length > 0 ||
          value.event.meetingRoomReservation?.length > 0 ||
          value.event.poolVehicleReservation?.length > 0)
      ) {
        dayListElements.push(
          <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={value.day.date.toString()}>
            <div className="of-plandate mt-1">
              <strong>
                {DateUtil.dateFormat(value.day?.date) + ' - ' + DateUtil.formatDayofWeek(value.day?.date)}
              </strong>
            </div>
          </div>
        )
      } else {
        dayListElements.push(
          <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={value.day.date.toString()}>
            <div className="of-plandate mt-1">
              <p>
                <strong>
                  {DateUtil.dateFormat(value.day?.date) + ' - ' + DateUtil.formatDayofWeek(value.day?.date)}
                </strong>
              </p>
            </div>
            <div className="of-plandate mt-2">
              {value.day.txtDay === undefined || value.day.txtDay === '' ? (
                <>
                  {value.event.planType === 20 || value.event.planType === 21 ? (
                    <div className="of-plandate of-plandate-label mt-1" style={{ marginBottom: 0 }}>
                      <span className="font-bold">
                        {value.event.planType === 20 ? t('calendar.leave') : t('calendar.report')}
                      </span>
                      <div className="of-label of-leave-report">
                        <span>{value.event.planType === 20 ? t('calendar.leave') : t('calendar.report')}</span>
                      </div>
                    </div>
                  ) : (
                    <div>{t('sidebar.no-notify-date')}</div>
                  )}
                </>
              ) : (
                <div>{value.day.txtDay}</div>
              )}
            </div>
          </div>
        )
      }

      /* Doctor Appointments */
      value.event?.doctorReservation?.forEach((f) => {
        dayListElements.push(
          <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
            <div className="of-plandate of-plandate-label mt-1">
              <strong>{f.reservationStartHourStr + ' - ' + f.reservationEndHourStr}</strong>
              <div className="of-label of-campus-health">
                <span>{t('plantype.campus-health-label')}</span>
                <img alt="" />
              </div>
            </div>

            <div className="of-plandate mb-4">
              <p>
                <div className="of-campus-doctor-icon"></div>
                <span> {t('appointment-modal.doctor-name')}: </span> {f.title + '  ' + f.name + ' ' + f.surname}
              </p>
            </div>
            <div className="d-flex align-items-center of-plan-location-block">
              <img src={listView} alt="" />
              <p>
                <span>{t('appointment-modal.doctor-specialty')}: </span>
                {f.specialty}
              </p>
            </div>
            <div className="of-plandate">
              <p>
                <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
                <span> {t('most-used-words.location')}: </span> {f.locationName}
              </p>
            </div>
            <div className="d-flex of-plan-location-block">
              <img src={binaGray} alt="" />
              <p>
                <span>{t('most-used-words.block')}: </span>
                {f.blockName}
                <br />
                <span>{t('most-used-words.floor')}: </span>
                {f.floorName}
              </p>
            </div>
          </div>
        )
      })
      /* Coiffeur Reservations */
      value.event?.coiffeurReservation?.forEach((f) => {
        dayListElements.push(
          <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
            <div className="of-plandate of-plandate-label mt-1">
              <strong>{f.reservationStartHourStr + ' - ' + f.reservationEndHourStr}</strong>
              <div className="of-label of-campus-coiffeur">
                <span>{t('plantype.campus-coiffeur-label')}</span>
                <img alt="" />
              </div>
            </div>

            <div className="of-plandate mb-3">
              <div className="d-flex align-items-center ">
                <div className="of-campus-coiffeur-icon"></div>
                <span> {t('coiffeur-res-modal.coiffeur-name')}: </span> &nbsp; {` ${f.fullName}`}
              </div>
            </div>
            <div className="of-plandate">
              <p>
                <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
                <span> {t('most-used-words.location')}: </span> {f.locationName}
              </p>
            </div>
            <div className="d-flex of-plan-location-block">
              <img src={binaGray} alt="" />
              <p>
                <span>{t('most-used-words.block')}: </span>
                {f.blockName}
                <br />
                <span>{t('most-used-words.floor')}: </span>
                {f.floorName}
              </p>
            </div>
          </div>
        )
      })
      /* Gym Salon Reservations */
      value.event?.gymSaloonReservation?.forEach((f) => {
        dayListElements.push(
          <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
            <div className="of-plandate of-plandate-label mt-1">
              <strong>
                {f.reservationStartHourStr + ' - ' + f.reservationEndHourStr} | {t('gym-res-modal.personal-res')}
              </strong>
              <div className="of-label of-campus-gym">
                <span>{t('plantype.campus-gym-salon-label')}</span>
                <img alt="" />
              </div>
            </div>

            <div className="of-plandate mb-3">
              <div className="d-flex align-items-center">
                <div className="of-campus-gym-icon"></div>
                <span> {t('gym-res-modal.salon-name')}:</span>&nbsp;{f.gymSaloonName}
              </div>
            </div>

            <div className="of-plandate">
              <p>
                <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
                <span> {t('most-used-words.location')}: </span> {f.locationName}
              </p>
            </div>
            <div className="d-flex of-plan-location-block">
              <img src={binaGray} alt="" />
              <p>
                <span>{t('most-used-words.block')}: </span>
                {f.blockName}
                <br />
                <span>{t('most-used-words.floor')}: </span>
                {f.floorName}
              </p>
            </div>
          </div>
        )
      })
      /* Gym Group Lesson Reservations */
      value.event?.gymGroupLessonReservation?.forEach((f) => {
        dayListElements.push(
          <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
            <div className="of-plandate of-plandate-label mt-1">
              <strong>
                {f.reservationStartHourStr + ' - ' + f.reservationEndHourStr} | {t('gym-res-modal.lesson-name')}
              </strong>
              <div className="of-label of-campus-gym">
                <span>{t('plantype.campus-gym-salon-label')}</span>
                <img alt="" />
              </div>
            </div>

            <div className="of-plandate mb-3">
              <div className="d-flex align-items-center">
                <div className="of-campus-gym-icon"></div>
                <span> {t('gym-res-modal.salon-name')}:</span>&nbsp;{f.gymSaloonName}
              </div>
            </div>
            <div className="d-flex align-items-center of-plan-location-block">
              <img src={listView} alt="" />
              <p>
                <span>{t('gym-res-modal.lesson-name')}: </span>
                {f.gymLessonTypeName}
              </p>
            </div>
            <div className="of-plandate">
              <p>
                <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
                <span> {t('most-used-words.location')}: </span> {f.locationName}
              </p>
            </div>
            <div className="d-flex of-plan-location-block">
              <img src={binaGray} alt="" />
              <p>
                <span>{t('most-used-words.block')}: </span>
                {f.blockName}
                <br />
                <span>{t('most-used-words.floor')}: </span>
                {f.floorName}
              </p>
            </div>
          </div>
        )
      })
      /* Gym Trainer Reservations */
      value.event?.gymTrainerReservation?.forEach((f) => {
        dayListElements.push(
          <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
            <div className="of-plandate of-plandate-label mt-1">
              <strong>
                {f.reservationStartHourStr + ' - ' + f.reservationEndHourStr} | {t('gym-res-modal.trainer-res')}
              </strong>
              <div className="of-label of-campus-gym">
                <span>{t('plantype.campus-gym-salon-label')}</span>
                <img alt="" />
              </div>
            </div>

            <div className="of-plandate mb-3">
              <div className="d-flex align-items-center">
                <div className="of-campus-gym-icon"></div>
                <span> {t('gym-res-modal.salon-name')}:</span>
                &nbsp;{f.gymSaloonName}
              </div>
            </div>
            <div className="d-flex align-items-center of-plan-location-block">
              <img src={avatar} alt="" />
              <p>
                <span>{t('gym-res-modal.trainer-name')}: </span>
                {f.gymTrainerFullName}
              </p>
            </div>
            <div className="of-plandate">
              <p>
                <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
                <span> {t('most-used-words.location')}: </span> {f.locationName}
              </p>
            </div>
            <div className="d-flex of-plan-location-block">
              <img src={binaGray} alt="" />
              <p>
                <span>{t('most-used-words.block')}: </span>
                {f.blockName}
                <br />
                <span>{t('most-used-words.floor')}: </span>
                {f.floorName}
              </p>
            </div>
          </div>
        )
      })
      /* Lactation Room Reservations */
      value.event?.lactationReservation?.forEach((f) => {
        dayListElements.push(
          <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
            <div className="of-plandate of-plandate-label mt-1">
              <strong>{f.reservationStartHourStr + ' - ' + f.reservationEndHourStr}</strong>
              <div className="of-label of-campus-lactation">
                <span>{t('plantype.campus-lactationRoom')}</span>
                <img alt="" />
              </div>
            </div>

            <div className="of-plandate mb-3">
              <div className="d-flex align-items-center">
                <div className="of-campus-lactation-icon"></div>
                <span> {t('lactation-res-modal.room-name')}:</span>&nbsp;{f.lactationRoomName}
              </div>
            </div>

            <div className="of-plandate">
              <p>
                <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
                <span> {t('most-used-words.location')}: </span> {f.locationName}
              </p>
            </div>
            <div className="d-flex of-plan-location-block">
              <img src={binaGray} alt="" />
              <p>
                <span>{t('most-used-words.block')}: </span>
                {f.blockName}
                <br />
                <span>{t('most-used-words.floor')}: </span>
                {f.floorName}
              </p>
            </div>
          </div>
        )
      })
      /* Meeting Room Reservations */
      value.event?.meetingRoomReservation?.forEach((f) => {
        dayListElements.push(
          <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
            <div className="of-plandate of-plandate-label mt-1">
              <strong>{f.reservationStartHourStr + ' - ' + f.reservationEndHourStr}</strong>
              <div className="of-label of-campus-meeting">
                <span>{t('plantype.campus-meetingRoom')}</span>
                <img alt="" />
              </div>
            </div>

            <div className="of-plandate mb-3">
              <div className="d-flex align-items-center">
                <div className="of-campus-meeting-icon"></div>
                <span> {t('meeting-res-modal.room-name')}:</span>&nbsp;{f.meetingRoomName}
              </div>
            </div>

            <div className="of-plandate">
              <p>
                <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
                <span> {t('most-used-words.location')}: </span> {f.locationName}
              </p>
            </div>
            <div className="d-flex of-plan-location-block">
              <img src={binaGray} alt="" />
              <p>
                <span>{t('most-used-words.block')}: </span>
                {f.blockName}
                <br />
                <span>{t('most-used-words.floor')}: </span>
                {f.floorName}
              </p>
            </div>
            <div className="of-plandate">
              <p>
                <i className="pi pi-users of-office-plan-icon" color="#A8A8A8" />
                {/* <img className="of-office-plan-icon" src={locationMarkerGray} alt="" /> */}
                <span> {f.capacity}</span>
              </p>
            </div>
          </div>
        )
      })
      /* Pool Vehicle Reservations */
      value.event?.poolVehicleReservation?.forEach((f) => {
        dayListElements.push(
          <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
            <div className="of-plandate of-plandate-label mt-1">
              <strong>{f.reservationStartHourStr + ' - ' + f.reservationEndHourStr}</strong>
              <div className="of-label of-campus-pool">
                <span>{t('plantype.campus-poolVehicle')}</span>
                <img alt="" />
              </div>
            </div>

            <div className="of-plandate mb-3">
              <div className="d-flex align-items-center">
                <div className="of-campus-pool-icon"></div>
                <span> {t('pool-vehicle-res-modal.brand-model')}:</span>&nbsp;{' '}
                {`${f.poolVehicleBrand} - ${f.poolVehicleModel}`}
              </div>
            </div>

            <div className="of-plandate">
              <p>
                <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
                <span> {t('most-used-words.location')}: </span> {f.locationName}
              </p>
            </div>
            <div className="d-flex of-plan-location-block">
              <img src={binaGray} alt="" />
              <p>
                <span>{t('pool-vehicle-res-modal.location-to-receive')}: </span>
                {f.locationToReceive}
                <br />
                <span>{t('pool-vehicle-res-modal.location-to-deliver')}: </span>
                {f.locationToDeliver}
              </p>
            </div>
            <div className="of-plandate">
              <p>
                <div className="of-campus-pool-icon"></div>
                <span> {t('pool-vehicle-res-modal.license-plate')}: </span> {f.poolVehiclePlate}
              </p>
            </div>
          </div>
        )
      })
    })

    return dayListElements
  }

  return <div className="multiple-sidebar-info">{getSideBarInfoRender()}</div>
}
